import { noEnvRoutes } from "@/assets/routes/routes";
import api from "@/lib/api";
import axios from "axios";

export const uploadImages = async (
  files: File[],
  route?: string,
): Promise<{ ok_files: string[]; ko_files: string[] }> => {
  const ok_files = [] as string[];
  const ko_files = [] as string[];

  for await (const file of files) {
    const response = await uploadImage(file, route);
    if (response.status) {
      ok_files.push(response.filename);
    } else {
      ko_files.push(response.filename);
    }
  }
  return { ok_files, ko_files };
};

export const uploadImage = async (
  file: File,
  route?: string,
): Promise<{ status: boolean; filename: string }> => {
  try {
    const fileRoute = `${route || ""}${file.name}`;

    const { data } = await api.post(noEnvRoutes.postImage, {
      filename: fileRoute,
      contentType: file.type,
      sizeBytes: file.size,
    });
    const publicUrl = data.url.replace(
      "http://mro-local-bucket.localstack:4566",
      "http://localhost:4566",
    );

    await axios.put(publicUrl, file, {
      headers: {
        "Content-Type": data.contentType,
      },
    });
    return { status: true, filename: fileRoute };
  } catch {
    return { status: false, filename: file.name };
  }
};
